<template>
    <div class="ion-padding">
        <ion-modal v-if="ModalOpen" ref="modal" :is-open="ModalOpen" :can-dismiss="canDismiss">
            <ion-header style="padding-top: 0px !important;">
                <ion-toolbar>
                    <ion-buttons slot="start">
                        <ion-button @click="closeModal">Cancel</ion-button>
                    </ion-buttons>
                    <ion-title>Career Application</ion-title>
                    <ion-buttons slot="end">
                        <ion-button :strong="true" @click="">Submit</ion-button>
                    </ion-buttons>
                </ion-toolbar>
            </ion-header style="padding-top: 0px !important;">
            <ion-content class="ion-padding">
                <ion-item id="application">
                    <form style="width:100%; max-width: 600px">
                        <ion-grid>
                            <ion-row>
                                <input ref="file" type="file" accept=".pdf,.docx,.png,.jpg"
                                    @change="onFileChanged"></input>
                            </ion-row>
                            <ion-row>

                                <ion-col>
                                    <ion-input ref="name" label="Full Name" labelPlacement="stacked" name="name"
                                        v-model="application.name" type="text" :spellcheck="false" autocapitalize="off"
                                        autocomplete="name" required></ion-input>
                                </ion-col>
                            </ion-row>
                            <ion-row>
                                <ion-col>
                                    <ion-input ref="phone" label="Phone Number" labelPlacement="stacked" name="phone"
                                        v-model="application.phone" type="tel" :spellcheck="false" autocapitalize="off"
                                        autocomplete="tel-local" required></ion-input>
                                </ion-col>
                                <ion-col>
                                    <ion-input ref="email" label="Email Address" labelPlacement="stacked" name="email"
                                        v-model="application.email" type="email" :spellcheck="false"
                                        autocapitalize="off" autocomplete="email" required></ion-input>
                                </ion-col>
                                <ion-col>
                                    <ion-select ref="contact" label="Preferred Contact Method" labelPlacement="stacked"
                                        name="contact" v-model="application.contactMethod" :spellcheck="false"
                                        autocapitalize="off" required>
                                        <ion-select-option value="disabled" selected disabled>Select
                                            Option</ion-select-option>
                                        <ion-select-option value="phone">Phone</ion-select-option>
                                        <ion-select-option value="email">Email</ion-select-option>
                                    </ion-select>
                                </ion-col>
                            </ion-row>
                            <ion-row>
                                <ion-col>
                                    <ion-select ref="position" label="Position" labelPlacement="stacked" name="position"
                                        v-model="application.position" :spellcheck="false" autocapitalize="off"
                                        required>
                                        <ion-select-option value="disabled" selected disabled>Select
                                            Option</ion-select-option>
                                        <ion-select-option value="Low Voltage Technician">Low Voltage
                                            Technician</ion-select-option>
                                        <ion-select-option value="High Voltage Electrician">High Voltage
                                            Electrician</ion-select-option>
                                        <ion-select-option value="Security Technician">Security
                                            Technician</ion-select-option>
                                    </ion-select>
                                </ion-col>
                            </ion-row>
                        </ion-grid>
                        <ion-item lines="none">
                            <ion-label style="text-align:center; font-size: x-large;">Work Experience</ion-label>
                            <ion-button
                                @click='() => application.workExperience.push({ employerName: "", jobTitle: "", startDate: "", endDate: "", description: "", to: false })'>Add
                                Experience</ion-button>
                        </ion-item>
                        <ion-item v-for="(exp, i) in application.workExperience" :key="i">
                            <ion-grid>
                                <ion-row>
                                    <ion-col>
                                        <ion-label style="font-size:large">Work Experience {{ i + 1 }}</ion-label>
                                    </ion-col>
                                    <ion-col>
                                        <ion-button color="danger"
                                            @click="application.workExperience.splice(i, 1)">Remove</ion-button>
                                    </ion-col>
                                </ion-row>
                                <ion-row>
                                    <ion-col>
                                        <ion-input :ref="'empName' + i" label="Employer Name" labelPlacement="stacked"
                                            name="employerName" v-model="application.workExperience[i].employerName"
                                            type="text" :spellcheck="false" autocapitalize="off" required></ion-input>

                                    </ion-col>
                                    <ion-col>
                                        <ion-input error-text="left pocket dogshit" :minlength="3" label="Job Title"
                                            labelPlacement="stacked" name="jobTitle"
                                            v-model="application.workExperience[i].jobTitle" type="text"
                                            :spellcheck="false" autocapitalize="off" required></ion-input>
                                    </ion-col>
                                </ion-row>
                                <ion-row>
                                    <ion-col>
                                        <ion-input label="Start Date" labelPlacement="stacked" name="startDate"
                                            v-model="application.workExperience[i].startDate" type="date"
                                            required></ion-input>

                                    </ion-col>
                                    <ion-col>
                                        <ion-checkbox label-placement="stacked"
                                            v-model="application.workExperience[i].to">Present</ion-checkbox>

                                    </ion-col>
                                    <ion-col>
                                        <ion-input label="End Date" labelPlacement="stacked" name="endDate"
                                            v-model="application.workExperience[i].endDate" type="date" required
                                            :disabled="application.workExperience[i].to"></ion-input>
                                    </ion-col>
                                </ion-row>
                                <ion-row>
                                    <ion-textarea label="Description" labelPlacement="stacked" name="description"
                                        v-model="application.workExperience[i].description" :spellcheck="false"
                                        autocapitalize="off" required></ion-textarea>
                                </ion-row>

                            </ion-grid></ion-item>
                        <ion-item>
                            <ion-grid>

                                <ion-row>
                                    <div>
                                        <ion-button style="justify-self: center;" size="large" form="modal"
                                            color="success" @click="submitApplication()"><ion-icon
                                                :icon="outlines.send"></ion-icon> Submit Application</ion-button>
                                    </div>
                                </ion-row>
                            </ion-grid>
                        </ion-item>
                    </form>
                </ion-item>
            </ion-content>
        </ion-modal>
    </div>
</template>
<script setup lang="ts">
import settings from "@/settings/email.json";

import { computed, ref, defineComponent, onMounted, watch } from "vue";
import {
    IonTextarea,
    IonCheckbox,
    IonPage,
    IonLabel,
    IonIcon,
    IonHeader,
    IonFooter,
    IonToolbar,
    IonButtons,
    IonSelectOption,
    IonGrid,
    IonMenuButton,
    IonButton,
    IonContent,
    IonList,
    IonItem,
    IonTitle,
    IonRow,
    IonCol,
    IonInput,
    IonToast,
    IonSelect,
    IonRadioGroup,
    IonRadio,
    toastController
} from "@ionic/vue";


const route = useRoute();
const router = useRouter();

var file = ref(null)


var ModalOpen = ref(false)

var canDismiss = ref(false); // Allow modal to be dismissed




watch(
    () => route.fullPath,
    (newPath) => {
        if (newPath.startsWith("/career")) {
            ModalOpen.value = true;
        } else {
            ModalOpen.value = false;
        }
    },
    { immediate: true }
);


interface WorkExperience {
    employerName: string;
    jobTitle: string;
    startDate: string;
    endDate: string;
    description: string;
    to: boolean;
}

let application = ref<{
    name: string;
    phone: string;
    email: string;
    contactMethod: string;
    position: string;
    workExperience: WorkExperience[];
}>({
    name: "",
    phone: "",
    email: "",
    contactMethod: "",
    position: "",
    workExperience: []
});
onMounted(() => {
    // Only open modal if on the correct route
    if (route.fullPath.startsWith("/requestquote")) {
        ModalOpen.value = true;
    }
    canDismiss.value = false;
});
var allowedSites = [
    "https://aes-site-revamp.pages.dev",
    "https://www.aes-site-revamp.pages.dev",
    "https://aes-site-revamp.pages.dev",
    "http://localhost:5173"
];
console.log(router.options.history.state.back == null)
function back() {
    if (router.options.history.state.back == null) {
        // If the back URL is one of the allowed sites, navigate back
        router.push("/")
        return;

    }

    router.back();
    ModalOpen.value = false

}
function onFileChanged() {
    let f = file.value as HTMLInputElement | null;
    if (f == null) {
        console.log("File input not found");
        return;
    }
    console.log(f.files)
    // if (files.length > 0) {
    //     const selectedFile = files[0];
    //     console.log("Selected file:", selectedFile);
    //     // You can now upload the file or process it as needed
    // }
}

async function submitApplication() {
    let val = settings.applicationBody

    val = val.replace("%req.name%", application.value.name)
    val = val.replace("%req.email%", application.value.email)
    val = val.replace("%req.number%", application.value.phone)
    val = val.replace("%req.contact%", application.value.contactMethod)
    val = val.replace("%req.position%", application.value.position)

    /*
    
    <ul>
            <li><b>Employer Name:</b> $comp.name%</li>
            <li><b>Job Title:</b> %comp.number%</li>
            <li><b>Start-End Date:</b> %comp.address1%</li>
            <li><b>Description:</b> %comp.address2%</li>
        </ul>
        */
    let inst = ""
    for (let i = 0; i < application.value.workExperience.length; i++) {
        const exp = application.value.workExperience[i];
        const start = formatDateMMDDYYYY(exp.startDate);
        const end = exp.to ? "Present" : formatDateMMDDYYYY(exp.endDate);
        const calculated = calculateDuration(exp.startDate, exp.to ? '' : exp.endDate);
        inst += `<ul>
            <li><b>Employer Name:</b> ${exp.employerName}</li>
            <li><b>Job Title:</b> ${exp.jobTitle}</li>
            <li><b>Start-End Date:</b> ${start} - ${end} : ${calculated}</li>
            <li><b>Description:</b> ${exp.description.replaceAll("\n", "<br>")}</li>
        </ul>`;
    }




    val = val.replace("<work-experience>", inst)
    val = val.replace("%def.datetime%", new Date().toLocaleString())
    let f = file.value as HTMLInputElement | null;
    let selectedFile: File | undefined = undefined;
    if (f && f.files && f.files.length > 0) {
        selectedFile = f.files[0];
    }

    let toastMessage = "";
    await sendEmail(
        settings.fromAddress,
        "jmeyer@aes-mlb.com",
        application.value.position + " Application for " + application.value.name,
        val,
        selectedFile
    ).then((test) => {
        console.log("Email sent successfully");
        toastMessage = "Your application has been submitted successfully! We will get back to you as soon as possible.";
    }).catch((error) => {
        console.error("Error sending email:", error);
        toastMessage = "There was an error submitting your application. Please try again later.";
    });
    const toast = await toastController.create({
        message: toastMessage,
        duration: 1500,
        position: "bottom",

    });

    toast.present();
    back()
    ModalOpen.value = false;

}


function formatDateMMDDYYYY(dateStr: string): string {
    if (!dateStr) return '';
    const [year, month, day] = dateStr.split('-');
    return `${month}/${day}/${year}`;
}

function calculateDuration(startDate: string, endDate: string): string {
    if (!startDate) return '';
    const start = new Date(startDate);
    const end = endDate && endDate !== 'Present' ? new Date(endDate) : new Date();
    let years = end.getFullYear() - start.getFullYear();
    let months = end.getMonth() - start.getMonth();
    let days = end.getDate() - start.getDate();
    if (days < 0) {
        months--;
        // Get days in previous month
        const prevMonth = new Date(end.getFullYear(), end.getMonth(), 0);
        days += prevMonth.getDate();
    }
    if (months < 0) {
        years--;
        months += 12;
    }
    return `${years} Year${years > 1 ? "s" : ""} ${months} Month${months > 1 ? "s" : ""} ${days} day${days > 1 ? "s" : ""}`;
}

function closeModal() {
    ModalOpen.value = false;
    canDismiss.value = false;
    // Use nextTick to ensure modal is removed before navigating
    setTimeout(() => {
        back()
    }, 100);
}









</script>



<script lang="ts">
import * as outlines from 'ionicons/icons';
import { sendEmail } from "@/EmailHelper";
import { useRoute, useRouter } from "vue-router";


</script>
